export default "__VITE_ASSET__6c2ccbb7__"